exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--userName__2EhGV{text-align:left;font-size:13px;line-height:15px;font-weight:500}.styles--userNameSmall__3XfEE{font-size:12px;line-height:14px}.styles--userDate__1VHMn{text-align:right;font-size:13px;line-height:15px;font-weight:600}.styles--userRetired__3spfE{color:#E35248;font-size:40px}.styles--userImg__3zJWG{position:relative}.styles--userImg__3zJWG img{border-radius:50%}.styles--userImg__3zJWG:after{display:block;content:\" \";width:9px;height:9px;border:2px solid #ffffff;position:absolute;right:0;bottom:0;border-radius:50%}.styles--hideLong__RVmoi{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.styles--flexCentered__L-Z6x{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}\n", ""]);

// exports
exports.locals = {
	"userName": "styles--userName__2EhGV",
	"userNameSmall": "styles--userNameSmall__3XfEE",
	"userDate": "styles--userDate__1VHMn",
	"userRetired": "styles--userRetired__3spfE",
	"userImg": "styles--userImg__3zJWG",
	"hideLong": "styles--hideLong__RVmoi",
	"flexCentered": "styles--flexCentered__L-Z6x"
};